var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-fluid d-flex h-100 background"},[_c('div',{staticClass:"container",attrs:{"id":"auth0"}})])
}]

export { render, staticRenderFns }